import React, { useEffect, useState } from 'react'
import { checkUserInfo, checkUserLocation, reformatCountriesToOptions } from '../helpers/form-helpers'
import { pipe, asyncPipe } from '../helpers/common'

// Fetching user data for forms
// Priority is data from cookies first, then from Kenneth account
// In cookies we're storing name, email, branch, country and location, and also location options
const withUserData = (WrappedComponent, Loading = null) => {
  const ComponentWithUserData = ({ countries, ...otherProps }) => {
    const [userInfo, setUserInfo] = useState(null)
    const [userLocation, setUserLocation] = useState(null)
    const countryOptions = reformatCountriesToOptions(countries)

    useEffect(() => {
      if (AD.userInfoReady) {
        pipe(checkUserInfo, setUserInfo)()
      } else {
        let userInitialized = false
        const kennethCallback = () => {
          pipe(checkUserInfo, setUserInfo)()
          userInitialized = true
        }
        $(document).on('kenneth:successful-login kenneth:anonymous-access', kennethCallback)

        // Force initialization of user after 8 seconds if no response from Kenneth
        setTimeout(() => {
          if (userInitialized) return
          $(document).off('kenneth:successful-login kenneth:anonymous-access', kennethCallback)
          pipe(checkUserInfo, setUserInfo)()
        }, 8000)
      }

      asyncPipe(checkUserLocation, setUserLocation)(countryOptions)
    }, [])

    if (Loading && !(userInfo && userLocation)) return <Loading />

    return (
      <WrappedComponent
        user={{ ...userInfo, ...userLocation }}
        countryOptions={countryOptions}
        loadingUser={!(userInfo && userLocation)}
        {...otherProps} />
    )
  }

  return ComponentWithUserData
}

export default withUserData